import { PublicSearchRegisteredPaItem } from "../../interfaces/public-search-registered-pa-item.interface";

export const publicAuthorisedPaSearchSortingDataAccessor = (data: PublicSearchRegisteredPaItem, sortHeaderId: string) => {
  return data[sortHeaderId].toLowerCase();
};
